const rabbitBreeds = [
  { value: 'unknown', label: { en: 'Unknown', es: 'Desconocido' } },
  { value: 'holland_lop', label: { en: 'Holland Lop', es: 'Holland Lop' } },
  { value: 'netherland_dwarf', label: { en: 'Netherland Dwarf', es: 'Enano de los Países Bajos' } },
  { value: 'mini_rex', label: { en: 'Mini Rex', es: 'Mini Rex' } },
  { value: 'flemish_giant', label: { en: 'Flemish Giant', es: 'Gigante Flamenco' } },
  { value: 'lionhead', label: { en: 'Lionhead', es: 'Cabeza de León' } },
  { value: 'english_lop', label: { en: 'English Lop', es: 'Lop Inglés' } },
  { value: 'rex', label: { en: 'Rex', es: 'Rex' } },
  { value: 'mini_lop', label: { en: 'Mini Lop', es: 'Mini Lop' } },
  { value: 'californian', label: { en: 'Californian', es: 'Californiano' } },
  { value: 'dutch', label: { en: 'Dutch', es: 'Holandés' } },
];

export default rabbitBreeds;